export const FeatureResponseDefault = {};
export const BusinessObjectiveResponseDefault = {};